import React from 'react'
import {Col, Row} from 'react-bootstrap';
import {dayMonthYearAtTimeWithSeconds} from "../../utils/dates";
import BreadcrumbItem from '../../component/BreadcrumbItem/BreadcrumbItem';
import EPCLink from "../../component/Asset/EPCLink";
import NodeSelector from '../../gateways/component/NodeSelector';
import {InputWithLabel} from '../../component/Form/InputWithLabel';

class SensingGrid {

  title = 'Lista de leituras dos nodes'

  customBreadcrumbs = [
    <BreadcrumbItem key={1} title="Lista de leituras dos nodes"/>,
  ]

  customFilters = {
    nodeIds: [],
    epc: null,
  }

  exportNewPage = true;
  showPdfButton = false;
  showNewButton = false;
  automaticDataFetch = true;
  automaticDataFetchIntervalInMilliseconds = 30000;

  columns = [
    {
      Header: "EPC's",
      accessor: 'asset.tags.value',
      Cell: ({original}) => {
        if (original.tagList && original.tagList.length > 0) {
          return original.tagList.map(x => {
            const epc = {value: x.epc.toUpperCase()};
            return <span><EPCLink epc={epc}/> - <b>{x.rssi}</b> <br/> </span>
          });
        }
        original.value = original.value && original.value.toUpperCase();
        return <EPCLink epc={original}/>
      }
    },
    {
      Header: 'Data/Hora da leitura',
      accessor: 'when',
      Cell: ({original}) => original.when && dayMonthYearAtTimeWithSeconds(
        original.when)
    },
    {
      Header: 'Node',
      accessor: 'bizLocation.friendlyName',
      HeaderColumn: true,
      Cell: ({original}) => {
        const node = original.readEquipment && original.readEquipment.node;
        if (node) {
          return <p> {node.uuid} - {node.friendlyName}</p>
        }
        return "Não identificado"
      }
    },
    {
      Header: 'RSSI',
      accessor: 'rssi',
      Cell: ({original}) => {
        const rssi = original.rssi && original.rssi;
        if (rssi) {
          return <p> {rssi} </p>
        }
        return "Não Informado"
      }
    },
    {
      Header: 'Status',
      width: 100,
      accessor: 'status',
    },
    {
      Header: 'Criado em',
      accessor: 'createdAt',
      Cell: ({original}) => original.createdAt && dayMonthYearAtTimeWithSeconds(
        original.createdAt)
    },
    {
      Header: 'Tipo',
      accessor: 'type'
    }
  ];

  customFilterComponent = (_props, _state, onChange) => {
    const handleEpc = (epc) => {
      this.customFilters.epc = epc
      onChange(this.customFilters)
    }

    const handleDateRangeSelect = (nodes) => {
      this.customFilters.nodeIds = nodes.map(x => x.id)
      onChange(this.customFilters)
    }

    return (
      <Row>
        <Col md={4}>
          <InputWithLabel
            placeholder="Buscar EPC"
            onChangeText={handleEpc}
            label="Filtro por EPC"
          />
        </Col>
        <Col md={4}>
          <NodeSelector multiple setValue={handleDateRangeSelect}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const params = new URLSearchParams({})
    const {customFilters} = this

    customFilters.epc && params.append('epcValue', customFilters.epc)
    customFilters.nodeIds && params.append('nodeIds', customFilters.nodeIds)

    return `cloud/v1/sensings?${params.toString()}`
  }
}

export default SensingGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/SensingGrid.js